import React from 'react'
import Button from './Button'

import ClearIcon from '../../../assets/icons/close.svg?react'
import useScreenSize from '../../../hocs/useScreenSize'

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  icon?: React.ReactElement
  showResetIcon?: boolean
  label?: string
}
const TextInput: React.FC<Props> = ({ label, className, icon, showResetIcon, ...rest }) => {
  const screenSize = useScreenSize()
  const ref = React.useRef<HTMLInputElement>(null)
  const resetValue = () => {
    if (ref.current) {
      ref.current.value = ''
      if(rest.onChange) {
        rest.onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)
      }
    }
  }
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (screenSize.isXs && e.key === 'Enter') {
      (e.target as HTMLInputElement).blur()
    }
  }
  const showLabel = (label && rest.value) || label && ref.current?.value && ref.current?.value?.toString().trim() !== ''
  return (
    <div className={icon ? 'flex items-center w-full' : ''}>
      {icon && (
        <div className='rounded-md relative'>
          <div className='pointer-events-none w-1 h-8 absolute top-1/2 transform -translate-y-1/2 left-3'>
            {React.cloneElement(icon, { className: 'w-5 ml-2' })}
          </div>
        </div>
      )}
      <div className='relative'>
        {showLabel && <span className='absolute px-5 top-1 text-3xs text-gray'>{label}</span>}
      </div>
      <input {...rest} onKeyDown={handleKeyDown} ref={ref} className={`h-[50px] rounded-full ${icon ? 'pl-12' : ''} ${showLabel ? 'pt-2' : 'py-2.5'} px-5 placeholder:text-gray text-xs sm:text-sm outline-soft-green ${className}`} />
      {showResetIcon && (
        <div className='rounded-md relative'>
          <div className='w-2 absolute top-1/2 transform -translate-y-1/2 right-20'>
            <Button variant='flat' type='button' onClick={resetValue}><ClearIcon className='stroke-gray w-6 h-6' /></Button>
          </div>
        </div>
      )}
    </div>
  )
}

// import MagIcon from '../../../assets/icons/mag-glass.svg?react'
// Example: <TextInput placeholder='Cuéntame qué necesitas...' icon={<MagIcon className='w-5' />} />

export default TextInput
